import React, { Component } from "react";
import GradientButton from "../input/GradientButton";

type OwnProps = {
  activeKey: Int,
  handleLogout: () => Promise<void>,
  onRequestShowAgenda: () => void,
  onRequestShowTaskList: () => void,
  onRequestShowTimeline: () => void,
};

type Props = OwnProps;

export default class NavBar extends Component {
  props: Props;

  render() {
    return (
      <div className={`project-nav ${this.props.isMobile ? "mobile-nav" : ""}`}>
        <div className="nav-item">
          <GradientButton
            gradient="1/5"
            handleClick={this.props.onRequestShowAgenda}
            title="Agenda"
          />
        </div>
        <div className="nav-item">
          <GradientButton
            gradient="2/5"
            handleClick={this.props.onRequestShowTimeline}
            title="Timeline"
          />
        </div>
        <div className="nav-item">
          <GradientButton
            gradient="3/5"
            handleClick={this.props.onRequestShowTaskList}
            title="Task List"
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/project-nav/ProjectNav.js